import { Dialog } from '@mui/material'

import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'

interface Props {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

function ConfirmDeleteDialog({ open, onClose, onConfirm }: Props): JSX.Element {
	return (
		<Dialog open={open} onClose={onClose}>
			<MDBox
				width="30vw"
				minWidth={320}
				style={{
					backgroundColor: '#fff',
				}}
			>
				<MDBox
					p={3}
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
					gap={2}
				>
					<MDTypography variant="h3">Confirm Deletion</MDTypography>
					<MDTypography variant="body2" color="text" fontWeight="regular" textAlign="center">
						Are you sure you want to delete this payphone location? This action cannot be undone.
					</MDTypography>
					<MDButton variant="contained" color="error" onClick={onConfirm}>
						Confirm Deletion
					</MDButton>
				</MDBox>
			</MDBox>
		</Dialog>
	)
}

export default ConfirmDeleteDialog
